import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom'
import PropTypes from "prop-types";
import './index.css';

class Drawer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: !!props.visible,
      destroyChild: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { visible, getContainer } = this.props;
    if (visible && prevProps.visible !== visible) {
        if(getContainer) {
          getContainer.style.overflow = 'hidden'
        }
      this.setState({ visible });
    }
  }

  handleClose = () => {
    const { onClose, getContainer, destroyOnClose } = this.props;
    if (onClose) {
      onClose();
    }
    if (getContainer) {
      getContainer.style.overflow = 'auto';
    }
    this.setState({
      visible: false,
    });
    if (destroyOnClose) {
      this.setState({
        destroyChild: true,
      })
    }
  };

  renderDrawerChild = () => {
    const {
      getContainer,
      zIndex,
      mask,
      maskClosable,
      width,
      children,
      closable,
      placement,
      drawerStyle,
    } = this.props;
    const { visible, destroyChild } = this.state;

    return (
      <div
        className="xDrawerWrap"
        style={{
          position: !getContainer ? 'absolute' : 'fixed',
          width: visible ? '100%' : '0',
          zIndex
        }}>
        { !!mask && <div
          className="xDrawerMask"
          role="none"
          onClick={maskClosable ? this.handleClose : null}/>}
        <div
          className="xDrawerContent"
          style={{
            width,
            [placement]: visible ? 0 : '-100%',
            ...drawerStyle
          }}>
          {destroyChild ? null : children}
          {!!closable && <span className="xCloseBtn" onClick={this.handleClose}>X</span>}
        </div>
      </div>
    );
  };

  render() {
    const { getContainer } = this.props;
    return !getContainer ? this.renderDrawerChild() : ReactDOM.createPortal(this.renderDrawerChild(), getContainer);
  }
}

Drawer.propTypes = {
  getContainer: PropTypes.shape({}),
  zIndex: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  visible: PropTypes.bool,
  mask: PropTypes.bool,
  maskClosable: PropTypes.bool,
  destroyOnClose: PropTypes.bool,
  closable: PropTypes.bool,
  placement: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.any),
  ]),
  drawerStyle: PropTypes.shape({}),
};
Drawer.defaultProps = {
  getContainer: document.body,
  visible: false,
  children: null,
  placement: 'right',
  drawerStyle: {},
  zIndex: 1,
  width: 800,
  mask: true,
  maskClosable: true,
  closable: true,
  destroyOnClose: false,
};

export default Drawer;
